// @dynamic-i18n-keys
//   studio.discountModal.form.appliesToCategoryInput.option.*
//   studio.discountModal.form.appliesToProductInput.option.*

// New helper: single AppliesToProduct field contains the final value
export function getAppliesToBabelKeyNew(appliesToProduct: string): string {
  if (appliesToProduct === 'any_tier') {
    return 'studio.discountModal.form.appliesToCategoryInput.option.subscriptions';
  } else if (appliesToProduct) {
    return `studio.discountModal.form.appliesToProductInput.option.${appliesToProduct}`;
  }
  return '';
}

// Old helper: two fields (AppliesToCategory + AppliesToProduct)
export function getAppliesToBabelKeyOld(
  appliesToCategory: string,
  appliesToProduct: string
): string {
  if (appliesToCategory === 'subscriptions') {
    return 'studio.discountModal.form.appliesToCategoryInput.option.subscriptions';
  } else if (appliesToCategory === 'shop_products') {
    return `studio.discountModal.form.appliesToProductInput.option.${appliesToProduct}`;
  }
  return '';
}
